import { toRaw } from 'vue';
import { useSocketStore } from '../stores/socketStore';
import { liveGrant } from '../api/messages';

/**
 * Calls `onChange(policyholderId)` whenever a conversation the viewer may see
 * changes, and `onChange(null)` after a reconnect, when anything may have been
 * missed. The socket only says which thread moved; callers refetch through the
 * scoped API. Returns `stop`.
 */
export function listenForMessages(onChange) {
  const socketStore = useSocketStore();
  let socket = null;
  let stopped = false;
  let joins = 0;

  const onEvent = (payload) => onChange(payload?.policyholder_id ?? null);

  const join = async () => {
    try {
      const { grant } = await liveGrant();
      if (stopped || !socket) return;
      socket.emit('messages:subscribe', { grant }, () => {
        if (joins++ > 0 && !stopped) onChange(null);
      });
    } catch (e) {
      // The page's slow poll still carries it.
    }
  };

  void (async () => {
    await socketStore.connect();
    socket = toRaw(socketStore.socket);
    if (stopped || !socket) return;
    socket.on('messages:changed', onEvent);
    socket.on('connect', join);
    if (socket.connected) void join();
  })();

  return () => {
    stopped = true;
    socket?.off('messages:changed', onEvent);
    socket?.off('connect', join);
  };
}
